import { Router } from '@angular/router';
import { SearchByVinViewModel } from './../../../ViewModels/TowLocateViewModels/SerchbyVinViewModel';
import { TowLocateSubjectService} from './../../../services/TowLocateServices/tow-locate-subject.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css']
})
export class ResultsComponent implements OnInit {
public SearchByVinViewModel = new SearchByVinViewModel();
public isMatch=false;
public noMatch = false;
  constructor(public TowLocateSubjectService: TowLocateSubjectService, public router: Router) { }

  ngOnInit() {
    this.TowLocateSubjectService.currentMessage.subscribe(message=>
      this.SearchByVinViewModel= message);
    if (!this.SearchByVinViewModel.isSearched) {
      this.router.navigate([`/HomePage`]);
    }
    else if(this.SearchByVinViewModel.isSearched=true && this.SearchByVinViewModel.vehicleInfo.vin!="" && this.SearchByVinViewModel.vehicleInfo.vin!=null)
    {
      this.isMatch=true;
    }
    else
    this.noMatch=true;
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/TowLocate/results/results.component.ts